import React from 'react';
import IAccessManager from '../api/IAccessManager';
import StubAccessManager from '../api/StubAccessManager';

const accessManager : IAccessManager = new StubAccessManager();
const AccessManagerContext = React.createContext(accessManager);

export default AccessManagerContext;
